import Client from './client';

export default class Ratecards extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getExportById(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/ratecards/${id}/export`, options);
  }

}
